/**
 * Base64エンコード
 * @param ストリング
 */
 export function base64EncodeUnicode(paramStr: string) {
    return btoa(encodeURIComponent(paramStr));
 }